export const toLower = (str) => str.toLowerCase();
export const kebab = (str) => str.replace(/ /g, '-');
